<template>
  <div>
    <Hero/>
    <Background/>
    <Guests/>
    <Partners/>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable */
import Hero from './components/Hero.vue'
import Background from './components/Background.vue'
import Guests from './components/Guests.vue'
import Partners from './components/Partners.vue'
import Footer from './components/Footer.vue'

export default {
  name: '2023',
  components: {
    Hero,
    Background,
    Guests,
    Partners,
    Footer
  }
}
</script>

